import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from '../reducer';

const configureStore = (initialState = {}) => createStore(reducer, initialState, applyMiddleware(thunk));

export default configureStore;



// WEBPACK FOOTER //
// ./src/universal/redux/store/production.js